/**
 * @generated SignedSource<<95ec8aa4c4721fd9f844272aa9c566a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainCreationInfo$data = {
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly subject: {
    readonly " $fragmentSpreads": FragmentRefs<"TodoSubject_TodoSubject">;
  } | null;
  readonly " $fragmentType": "TodoEditNewMainCreationInfo";
};
export type TodoEditNewMainCreationInfo$key = {
  readonly " $data"?: TodoEditNewMainCreationInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainCreationInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainCreationInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubject",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoSubject_TodoSubject"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "498a67c1b68e27ba42bd0e049abc1f62";

export default node;
